var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRsGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rs-google",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Cover",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M5.282,146.234l-.83,3.1L1.42,149.4a11.937,11.937,0,0,1-.088-11.128h0l2.7.495,1.183,2.683a7.112,7.112,0,0,0,.067,4.788Z",
    transform: "translate(1.083 -130.749)",
    fill: "#fbbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M273.074,208.176a11.912,11.912,0,0,1-4.248,11.519h0l-3.4-.173-.481-3A7.1,7.1,0,0,0,268,212.89h-6.372v-4.714h11.446Z",
    transform: "translate(-248.367 -197.402)",
    fill: "#518ef8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M48.465,316.215h0a11.921,11.921,0,0,1-17.957-3.646l3.862-3.161a7.087,7.087,0,0,0,10.213,3.629Z",
    transform: "translate(-28.005 -293.923)",
    fill: "#28b446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M46.815,2.743,42.954,5.9A7.086,7.086,0,0,0,32.507,9.615L28.625,6.436h0A11.919,11.919,0,0,1,46.815,2.743Z",
    transform: "translate(-26.209 1.083)",
    fill: "#f14336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsGoogle);
export default __webpack_public_path__ + "static/media/fi-rs-google.a51a2d46dc9b0bdbee8a05993031167c.svg";
export { ForwardRef as ReactComponent };